import { DEFAULT_ASPECT_RATIO, detectAspectRatio, type CreateMakeoverRequest } from '@paint-ai/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { prepareImageForUpload } from '@/lib/image';
import { queryKeys } from '@/lib/query-keys';
import { makeoversApi } from '../api';

export type MakeoverDraft = Omit<CreateMakeoverRequest, 'image' | 'aspectRatio'> & { imageSrc: string };

/** Uploads the photo + colour scheme, renders it, and refreshes history on success. */
export function useCreateMakeover() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ imageSrc, ...rest }: MakeoverDraft) => {
      const image = await prepareImageForUpload(imageSrc);
      return makeoversApi.create({
        ...rest,
        image: image.dataUrl,
        aspectRatio: image.width ? detectAspectRatio(image.width, image.height) : DEFAULT_ASPECT_RATIO,
      });
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.generations.all }),
  });
}
